export default __webpack_public_path__ + "static/media/5.fe9ebe66.jpg";